import { EnnismoreAPIClientConfig } from './interfaces';

export function getClientHeaders(config: EnnismoreAPIClientConfig) {
  if (config.membershipMode && config.gatewayType === 'aws-api-gateway') {
    return {
      'x-skip-teleport': 'true',
    };
  }

  if (config.gatewayType === 'kong') {
    return {
      'x-client': 'booking-platform-web',
      'x-application': 'ebe-ui',
    };
  }

  return {};
}
